import React from 'react'
import styles from './BottomBar.module.css'

import IconForward from '../../../../../assets/icons/IconForward'
import IconBack from '../../../../../assets/icons/IconBack'

export const BOTTOM_BAR_HIDE = 0
export const BOTTOM_BAR_NAVIGATION = 1
export const BOTTOM_BAR_FINISH = 2
export const BOTTOM_BAR_CHECK = 3

const BottomBar = ({
    onNext,
    onBack,
    progress,
    maxProgress,
    mode,
    enabled,
    onCheck,
    text,
}) => {

    let content = null
    switch (mode) {
        case BOTTOM_BAR_NAVIGATION:
            content = <>
                {
                    progress === 0 ? <div /> :
                        <div
                            className={styles.buttonBack}
                            onClick={onBack}>
                            <IconBack size={24} />
                        </div>
                }
                <div
                    className={styles.buttonNext}
                    onClick={onNext}>
                    <p className={styles.buttonNextTitle}>
                        {progress + 1 >= maxProgress ? 'Finish' : 'Next'}
                    </p>
                    {
                        progress + 1 >= maxProgress ? null :
                            <IconForward size={24} />
                    }

                </div>
            </>
            break
        case BOTTOM_BAR_FINISH:
            content = <>
                {
                    progress >= maxProgress ?
                        <div
                            className={styles.buttonFinish}
                            onClick={onNext}>
                            <p className={styles.buttonFinishTitle}>
                                {'Finish'}
                            </p>
                        </div> : null
                }
            </>
            break;

        case BOTTOM_BAR_CHECK:
            content = <div
                onClick={enabled ? onCheck : null}
                className={styles.buttonCheck}
                style={enabled ? {} : { opacity: 0.3 }}>
                <p className={styles.buttonCheckTitle}>
                    {text ? text : 'Check'}
                </p>
            </div>
            break

        default: content = null;
    }

    return (
        <div
            className={styles.container}
            style={mode === BOTTOM_BAR_FINISH || mode === BOTTOM_BAR_CHECK ? { justifyContent: 'center' } : {}}>
            {content}
        </div>
    )
}

export default BottomBar
